module.exports = __webpack_public_path__ + "img/vswiper2.224c7cbd.png";